module.exports = __webpack_public_path__ + "static/assets/aaa4a3575852fe11d04f44c4a972ae73.svg";